// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wh8y_pvS62QoOHaMXiUt{grid-template-rows:108px 1fr 108px;height:100%;display:grid}.dPdoIoSRysbXksXJTdWm{flex-direction:column;justify-content:center;align-items:center;display:flex}.H6nXraKRA04dmOU6KCSC{justify-content:center;align-items:flex-end;padding-bottom:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Wh8y_pvS62QoOHaMXiUt`,
	"content": `dPdoIoSRysbXksXJTdWm`,
	"footer": `H6nXraKRA04dmOU6KCSC`
};
export default ___CSS_LOADER_EXPORT___;
